import classNames from "classnames";
import { Tour } from "../../../../../interface/model/tour";

interface TourAccommodationProps {
  className?: string;
  data: Tour;
}

export default function TourAccommodation({
  className,
  data,
}: TourAccommodationProps) {
  return (
    <div
      className={classNames(
        "mt-10",
        className
      )}
    >
      Tour Accommodation
    </div>
  )
}